
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/partner-introduction",
      function () {
        return require("private-next-pages/partner-introduction/index.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/partner-introduction"])
      });
    }
  